import React from 'react';
import { IDropDownItem } from '@marqvision/mds/core/DropDown';
import { SelectedTag } from './@components/SelectedTag';
import { FilterChipProps } from './@types';

export const getSelectedTags = ({ type, selected, dropdownList, label, color }: FilterChipProps): React.ReactElement | React.ReactElement[] | undefined => {
  if (!selected) return;

  if (type === 'select') {
    if (Array.isArray(selected)) {
      if (!selected.length) return;
      // 전체선택 시 All tag 노출
      if (selected[0] === -1 || selected.length === getTotalCount(dropdownList)) {
        return <SelectedTag color={color}>All</SelectedTag>;
      }
      // 선택 아이템 1개 이상일 시 첫번째 태그 = label, 두번째 태그 = 잔여 아이템 갯수
      if (selected.length > 1) {
        return [
          <SelectedTag key={selected[0].value} color={color}>{selected[0].label}</SelectedTag>,
          <SelectedTag key={`${label}-rest-options`} color={color}>{`+${(selected.length - 1).toLocaleString()}`}</SelectedTag>,
        ];
      }
      // multi select 이나 선택된 아이템 1개면 태그 하나에 label 노출
      return <SelectedTag color={color}>{selected[0].label}</SelectedTag>
    }
    // 단일 옵션 선택 시 태그 하나에 label 노출
    return <SelectedTag color={color}>{selected.label}</SelectedTag>;

  } else if (type === 'other') {
    // other type 일 경우 selected 에 출력할 label 만 전달받음
    return <SelectedTag color={color}>{selected}</SelectedTag>;
  }

  return;
};

const getTotalCount = (item: IDropDownItem[]): number => {
  return item.reduce((prev, cur) => prev + (cur.children ? getTotalCount(cur.children) : 1), 0);
};